// CrewMagic dashboard root — composes the canvas frontpage:
// paper background + header (logo/picker/search/theme/avatar) +
// notif strip + canvas (with nodes/edges/legend/zoom/addzone) +
// the click-into agent modal (mounted alongside; conditional render).

import { Header } from "./Shell/Header"
import { NotifStrip } from "./Approvals/NotifStrip"
import { Canvas } from "./Canvas/Canvas"
import { AgentModal } from "./AgentModal/AgentModal"
import { NewAgentModal } from "./NewAgentModal/NewAgentModal"
import { CompanyModal } from "./CompanyModal/CompanyModal"
import { SectionsSidebar } from "./Sidebar/SectionsSidebar"

export function App() {
  return (
    <>
      <div className="cm-paper-bg" />
      <div className="cm-app">
        <Header />
        <NotifStrip />
        <div className="cm-body">
          <SectionsSidebar />
          <Canvas />
        </div>
      </div>
      <AgentModal />
      <NewAgentModal />
      <CompanyModal />
    </>
  )
}
